// ============= Imports =============
import { SignalRContextProps } from '@/contexts/SignalRContext';

// ============= Constants =============
// Hub name must match the hub name configured in environment variables
// e.g., VITE_SIGNALR_HUB_PATH_ASKMESSAGERELAYHUB=/hubs/AskMessageRelayHub
const HUB_NAME = 'askRelayHub';

// ============= Types =============
export interface AddClientToGroupAskSessionProps {
  invokeHub: SignalRContextProps['invokeHub'];
  askSessionId: string;
  userId: string;
}

// ============= Main Function =============
/**
 * Adds the client to a group in AskMessageRelayHub
 * @param invokeHub Function to invoke SignalR hub methods
 * @param askSessionId The askSession ID to join
 * @param userId The user ID to join
 * @returns Promise with API response or error
 */
export const addClientToGroupAskSession = async ({
  invokeHub,
  askSessionId,
  userId,
}: AddClientToGroupAskSessionProps): Promise<any> => {
  try {
    console.log(
      `🔄 Adding client to group [${askSessionId}] in AskMessageRelayHub...`
    );

    if (!askSessionId || !userId) {
      throw new Error('askSessionId and userId are required');
    }

    const result = await invokeHub<any>(
      HUB_NAME,
      'AddClientToGroupAsync',
      askSessionId,
      userId
    );

    console.log(`✅ Client added to group [${askSessionId}] successfully`);
    return result;
  } catch (error) {
    console.error(
      `🔴 Error adding client to group [${askSessionId}] for user [${userId}] in AskMessageRelayHub:`,
      error
    );
    throw error;
  }
};
